var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12 d-flex flex-column mb-3" }, [
    _c("div", { staticStyle: { flex: "1", "margin-left": "45px" } }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("section-title", {
              attrs: { title: _vm.$t("apps.inventory.label.serialnumber") }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row mb-1" },
      _vm._l(_vm.value, function(item, index) {
        return _c("div", { key: index, staticClass: "col-12" }, [
          _c("div", { staticClass: "form-row" }, [
            _c(
              "div",
              {
                ref: "ser-wrapper",
                refInFor: true,
                staticClass: "ser-wrapper mb-2",
                class: [
                  { "col-md-9": !_vm.disabled, "col-md-8": _vm.disabled },
                  _vm.serClassName
                ]
              },
              [
                _c("div", { staticClass: "d-flex" }, [
                  _c("div", { staticStyle: { width: "45px" } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-row", staticStyle: { flex: "1" } },
                    [
                      _c("div", { staticClass: "col-12" }, [
                        _c("div", { staticClass: "form-row form-row-items" }, [
                          _c("div", { staticClass: "col-3" }, [
                            _c(
                              "div",
                              { staticClass: "input-group" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "input-group-prepend" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "input-group-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("apps.inventory.message.bin")
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("BaseDropdown", {
                                  attrs: {
                                    options: _vm.binOptions,
                                    disabled: _vm.disabled
                                  },
                                  model: {
                                    value: item.binId,
                                    callback: function($$v) {
                                      _vm.$set(item, "binId", $$v)
                                    },
                                    expression: "item.binId"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-3" }, [
                            _c(
                              "div",
                              { staticClass: "input-group" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "input-group-prepend" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "input-group-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "apps.inventory.message.serialnumber"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("BaseInput", {
                                  attrs: { disabled: _vm.disabled },
                                  model: {
                                    value: item.serialNumber,
                                    callback: function($$v) {
                                      _vm.$set(item, "serialNumber", $$v)
                                    },
                                    expression: "item.serialNumber"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-2" }, [
                            _c(
                              "div",
                              { staticClass: "input-group" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "input-group-prepend" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "input-group-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "apps.inventory.message.dateproduct"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("BaseInputDatePicker", {
                                  attrs: { disabled: _vm.disabled },
                                  model: {
                                    value: item.dateProduct,
                                    callback: function($$v) {
                                      _vm.$set(item, "dateProduct", $$v)
                                    },
                                    expression: "item.dateProduct"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-2" }, [
                            _c(
                              "div",
                              { staticClass: "input-group" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "input-group-prepend" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "input-group-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "apps.inventory.message.dateexpire"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("BaseInputDatePicker", {
                                  attrs: { disabled: _vm.disabled },
                                  model: {
                                    value: item.dateExpire,
                                    callback: function($$v) {
                                      _vm.$set(item, "dateExpire", $$v)
                                    },
                                    expression: "item.dateExpire"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-2" }, [
                            _c(
                              "div",
                              { staticClass: "input-group" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "input-group-prepend" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "input-group-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "apps.inventory.message.cost"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("BaseInputNumber", {
                                  attrs: { disabled: _vm.disabled },
                                  model: {
                                    value: item.cost,
                                    callback: function($$v) {
                                      _vm.$set(item, "cost", $$v)
                                    },
                                    expression: "item.cost"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        index < _vm.value.length - 1
                          ? _c("div", { staticClass: "row" }, [_vm._m(0, true)])
                          : _vm._e()
                      ])
                    ]
                  )
                ])
              ]
            )
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("hr", { staticStyle: { margin: "15px 0 5px 0" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8010b5f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8010b5f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseGRPutAwaySerial.vue
// module id = null
// module chunks = 